<!-- demandタブで使えるラベル付きselectコンポーネント vmodelは汎用的に-->
<template>
  <div class="field">
    <label> {{label}} </label>
    <div>
      <select v-if="vmodel" v-model="vmodel" :disabled="disabled">
        <option
          selected
          v-for="option in options"
          :value="option.value"
          :key="option.value"
        >
          {{ option.string }}
        </option>
      </select>
      <select v-else :disabled="disabled">
        <option
          selected
          v-for="option in options"
          :value="option.value"
          :key="option.value"
        >
          {{ option.string }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
import { useVModel } from "vue-composable";
export default {
  name: "demandSelectForm",
  props: {
    vmodel:{
      type: String,
      require: true,
      default: null
    },
    label:{
      type: String,
      require: true
    },
    options:{
      type: Array,
      require: true
    },
    disabled: {
      type: Boolean,
      require: false,
      default: false
    }
  },
  setup(props) {
    const vmodel = useVModel(props, "vmodel");
  },
};
</script>
<style scoped lang="scss">

.field {
  position: relative;
  margin: auto;
  width: 95%;
  padding-bottom: 10px;
}

.field label {
  position: absolute;
  width: 150px;
  z-index: 100;
  top: 0;
  margin-top: 15px;
  margin-left: 15px;
  font-size: 13px;
  color: #888888;
}

select {
  -webkit-appearance: none;
  width: 100%;
  height: 38px;
  margin-bottom: 0;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  background-color: #ffffff;
  outline: none;
  padding: 5px 10px 5px 150px;
  font-size: 16px;
  line-height: 16px;
  font-weight: bold;
  color: #000000;
}

select:focus {
  border-color: #e0e0e0;
}

select:disabled {
  border-color: #e0e0e0;
  background-color: #f0f0f0;
}

.select-wrap {
  width: 100%;
  position: relative;
  display: inline-block;
  border-radius: 0;
}

.select-wrap::after {
  content: "";
  width: 6px;
  height: 6px;
  border: 0px;
  border-bottom: solid 2px #b4b3b3;
  border-right: solid 2px #b4b3b3;
  -ms-transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  position: absolute;
  top: 20px;
  right: 15px;
  margin-top: -6px;
}

input:focus {
  border: 1px solid #e0e0e0;
  background: white;
}

.caution {
  margin: 0px 10px 5px;
  text-align: right;
  color: red;
  font-size: 13px;
}

.select-wrap {
  width: 100%;
  position: relative;
  display: inline-block;
  border-radius: 0;
}
.item-frame {
  text-align: center;
  margin-bottom: 10px;
}
.switch {
  position: relative;
  &:before,
  &:after {
    content: "";
    vertical-align: middle;
    display: inline-block;
  }
  &:before {
    width: 2em;
    height: 1em;
    border: 2px solid #e0e0e0;
    border-radius: 32px;
    background: #999;
  }
  &:after {
    position: relative;
    width: 1em;
    height: 1em;
    background: #e0e0e0;
    border-radius: 50%;
    left: -2.2em;
  }
}
input {
  display: none;
  &:checked {
    ~ .switch {
      &:before {
        background: #7dc270;
        border-color: #7dc270;
      }
      &:after {
        left: -1.1em;
      }
    }
  }
}
</style>
